<script lang="ts">
	//Hooks
	import { afterUpdate, beforeUpdate } from 'svelte';
	//Stores
	import { readDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	import { devices_config } from '@devices/index';
	// Components
	import { Select, toast, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { localReq, postReq } from '../../../services/http';
	import { format } from 'svelte-i18n';
	import { get_local_ip } from 'src/helpers/interface_helpers';
	import type {
		ControlCloudEffectsRequest,
		ControlLocalEffectsRequest,
	} from 'src/types/requests/services/control_effects';
	import { capFirstChar } from 'src/helpers/utilities';

	export let device;

	let settingsEffects = [];
	let selected: number;
	let localIp = false;
	if (readDeviceStatus(device.id)?.lights) {
		selected = 0;
	}
	let res;
	let selectedValue = '';
	let optionsSelect = [];

	beforeUpdate(() => {
		localIp = get_local_ip(device.id);

		const status = readDeviceStatus(device.id);
		if (status?.lights?.[device.channel]?.effect != selected) {
			selected = status.lights[device.channel].effect || 0;
		}

		settingsEffects = devices_config[device?.type]?.modes?.color?.effects || [];
	});

	afterUpdate(() => {
		optionsSelect = [];

		for (const effect of settingsEffects) {
			const effectOption = {
				title: $format(
					'select_title_light_effect_' + effect.label.toLowerCase().replace(/\s+/, '_'),
					{
						default: capFirstChar(effect.label.toLowerCase()),
					},
				),
				value: effect.id,
			};
			optionsSelect.push(effectOption);
			if (effect.id === selected) {
				selectedValue = effectOption;
			}
		}
	});

	const cloudEffectsRequest = async (data) => {
		const res: ControlCloudEffectsRequest = await postReq(
			'device/light/settings/effect',
			data,
			undefined,
			device.shared ? device.server : undefined,
		);
		if (res.isok) {
			return res;
		} else {
			toast.open({ type: 'danger', title: $format('error_global') });
		}
	};

	const sendRequest = async (effect, id, channel) => {
		if (localIp) {
			const url = `${localIp}/${device.category}/${device.channel}`;

			const res: ControlLocalEffectsRequest = await localReq(
				device,
				url,
				'post',
				{
					effect,
				},
				9000,
			);
			if (res.isok) {
				selected = res.effect;
			} else {
				await cloudEffectsRequest({
					effect,
					id,
					channel,
				});
			}
		} else {
			await cloudEffectsRequest({
				effect,
				id,
				channel,
			});
		}
	};
</script>

<Text styleType="controls-large" class="mb-s text-bold">
	{$format('collapse_title_effects', {
		default: 'Effects',
	})}
</Text>
<Select
	icon="fak fa-solid-sparkles"
	id="select-light-effects"
	aria-label={$format('label_select_light_effect', {
		default: 'Select light effect',
	})}
	options={optionsSelect}
	value={selectedValue}
	on:change={async (e) => {
		await sendRequest(e.detail['value'], device.id, device.channel);
	}}
/>
